<template>
  <div>
    <div class="card-body card-body-page">
      <div class="accordion">
        <!-- @slot Deve ser um ou mais accordionItem -->
        <slot> </slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Um espaço para adicionar os itens de accordion
 */
export default {
  name: "Accordion",
  props: {
    /**
     * Define se varios accordions podem ser abertos ao mesmo tempo
     */
    multipleOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { accordions: [] }
  },
  provide () {
    return {
      onToogle: this.onToogle,
      addAccordion: this.addAccordion,
      removeAccordion: this.removeAccordion
    }
  },
  methods: {
    onToogle (item) {
      if (item.isOpenLocal === true && this.multipleOpen === false) {
        this.accordions.forEach( x => {
          if( x !== item ){
            x.toogle(false)
          }
        })
      }
    },
    addAccordion (item) {
        this.accordions.push(item)
    },
    removeAccordion (item) {
      this.accordions = this.accordions.filter( x=> x !== item)
    }
  }
};
</script>
